var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", attrs: { tag: "div" } },
    [
      _vm.radios.length > 0
        ? _c("div", [
            _c("div", { staticClass: "flex margin-top" }, [
              _c(
                "div",
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c(
                                "el-radio-group",
                                {
                                  staticClass: "radio-group",
                                  attrs: { name: "radios" },
                                  on: { input: _vm.changeRadio },
                                  model: {
                                    value: _vm.valRadioInicial,
                                    callback: function($$v) {
                                      _vm.valRadioInicial = $$v
                                    },
                                    expression: "valRadioInicial"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "container" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex-buttons input",
                                        class: { erro: errors.length }
                                      },
                                      _vm._l(
                                        _vm.isDecisao
                                          ? _vm.radiosParecer
                                          : _vm.radiosDespacho,
                                        function(r) {
                                          return _c(
                                            "el-radio",
                                            {
                                              key: r.valor,
                                              staticClass: "margin",
                                              attrs: {
                                                border: true,
                                                label: r.valor
                                              }
                                            },
                                            [_vm._v(_vm._s(r.nome))]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ])
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3384001349
                    )
                  }),
                  _vm.showSelecionaUsuario && _vm.isDespacho
                    ? _c(
                        "div",
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "el-card",
                                        {
                                          staticClass: "card container-select",
                                          attrs: { shadow: "hover" }
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              "Selecione o " +
                                                _vm._s(_vm.perfil) +
                                                " :"
                                            )
                                          ]),
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "full-width input",
                                              class: { erro: errors.length },
                                              attrs: {
                                                placeholder:
                                                  "Selecione o responsável",
                                                "no-match-text":
                                                  "Usuário não encontrado",
                                                "no-data-text":
                                                  "Nenhum usuário disponível",
                                                filterable: "filterable",
                                                clearable: "clearable"
                                              },
                                              model: {
                                                value: _vm.changeUsuario,
                                                callback: function($$v) {
                                                  _vm.changeUsuario = $$v
                                                },
                                                expression: "changeUsuario"
                                              }
                                            },
                                            _vm._l(
                                              _vm.usuariosDisponiveis,
                                              function(usuario) {
                                                return _c("el-option", {
                                                  key: usuario.id,
                                                  attrs: {
                                                    label:
                                                      usuario.pessoa
                                                        .pessoaFisica.nome,
                                                    value: usuario.id
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              424320229
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b7d305e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b7d305e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppRadiosTramitacao.vue
// module id = null
// module chunks = 